import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BellRing, CalendarDays, Megaphone, Newspaper } from "lucide-react";
import { api, formatDate } from "@/lib/api";

const ICONS = { notice: Megaphone, news: Newspaper, event: CalendarDays };
const FILTERS = [["all", "All"], ["notice", "Notices"], ["news", "News"], ["event", "Events"]];

export const AnnouncementsFeed = () => {
  const [feed, setFeed] = useState(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    api("/account/feed").then(d => { setFeed(d); if (d.unseen) api("/account/feed/seen", { method: "POST" }).catch(() => {}); }).catch(() => setFeed({ items: [], unseen: 0 }));
  }, []);
  const items = (feed?.items || []).filter(i => filter === "all" || i.kind === filter);

  return (
    <section className="account-card feed-card" data-testid="announcements-feed">
      <div className="feed-head">
        <h3><BellRing size={18} /> Announcements {feed?.unseen > 0 && <span className="badge-new" data-testid="feed-unseen-count">{feed.unseen} new</span>}</h3>
        <div className="chips" role="tablist">
          {FILTERS.map(([k, l]) => <button type="button" key={k} className={filter === k ? "chip active" : "chip"} onClick={() => setFilter(k)} data-testid={`feed-filter-${k}`}>{l}</button>)}
        </div>
      </div>
      {!feed ? <div className="hint">Loading updates…</div> : items.length ? (
        <div className="feed-list">
          {items.map(it => {
            const Icon = ICONS[it.kind] || Newspaper;
            return (
              <Link to={it.url} className={it.is_new ? "feed-item new" : "feed-item"} key={`${it.kind}-${it.id}`} data-testid={`feed-item-${it.id}`}>
                <span className="feed-icon"><Icon size={16} /></span>
                <div>
                  <div className="feed-meta">
                    <span className="card-kicker">{it.category}</span>
                    {it.is_new && <span className="badge-new" data-testid={`feed-new-${it.id}`}>New</span>}
                  </div>
                  <b>{it.title}</b>
                  {it.summary && <p>{it.summary}</p>}
                  <small>{it.kind === "event" ? `${it.date ? formatDate(it.date) : ""}${it.venue ? ` · ${it.venue}` : ""}` : it.stamp ? `Posted ${formatDate(it.stamp)}` : ""}</small>
                </div>
                <ArrowRight size={14} />
              </Link>
            );
          })}
        </div>
      ) : <div className="hint" data-testid="feed-empty">No announcements in this category yet.</div>}
    </section>
  );
};
